import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import India from "../Components/India";
import IndiaSubPage from "../Components/India/id";

import { INDIA_SUB_PAGES } from "../Config/Static/ProgramDetail/India";

function IndiaContainer() {
  const navigate = useNavigate();
  const { pageId } = useParams();
  useEffect(() => {
    if (pageId) {
      const isPresent = INDIA_SUB_PAGES.find((x) => x.slug === pageId);
      if (!isPresent) navigate("/404-found");
    }
  }, [pageId, navigate]);
  return (
    <>
      <Helmet>
        <title>
          NISSAN MOTOR CORPORATION - GLOBAL CAREER WEBSITE - MIDDLE EAST
        </title>
      </Helmet>
      <main className="americas-container india-container">
        {!pageId ? <India /> : <IndiaSubPage pageId={pageId} />}
      </main>
    </>
  );
}

export default IndiaContainer;
